// Format registry: detection by magic numbers and a safe parse wrapper.
import { mp3Parser } from './mp3';
import { adtsParser } from './adts';
import { flacParser } from './flac';
import { oggParser } from './ogg';
import { mp4Parser } from './mp4';
import { wavParser } from './wav';
import { aiffParser } from './aiff';
import { id3Explanations } from './id3';
import { vorbisCommentExplanations } from './vorbiscomment';
import type { Explanation, FormatParser, ParsedFile } from './types';

// Order matters: strict signatures first, sync-word formats (ADTS before MP3) last.
export const parsers: FormatParser[] = [wavParser, aiffParser, flacParser, oggParser, mp4Parser, adtsParser, mp3Parser];

export const allExplanations: Record<string, Explanation> = Object.assign(
  {
    'gap.unknown': {
      title: 'Unrecognized bytes',
      body: 'No part of the format claims these bytes. They can be damage, junk left by an editor, or data from a format this tool does not know. Players usually skip them.',
    },
    'gap.zeros': {
      title: 'Zero bytes',
      body: 'A run of bytes that are all zero and belong to no known block. Programs often leave zeros as spare room, or when a download or copy stopped early.',
    },
  },
  vorbisCommentExplanations,
  id3Explanations,
  ...parsers.map((p) => p.explanations),
);

export function detect(bytes: Uint8Array): FormatParser | undefined {
  for (const p of parsers) {
    try {
      if (p.detect(bytes)) return p;
    } catch {
      /* a detector failing just means "not this format" */
    }
  }
  return undefined;
}

/** A minimal result for files we cannot parse, so the hex view still works. */
export function rawFile(bytes: Uint8Array): ParsedFile {
  return {
    format: 'mp3', container: 'Unknown', size: bytes.length,
    segments: [], frames: [], tags: [], pictures: [], notes: [],
    audio: { codec: 'Unknown', lossless: false },
  };
}
